<p-dialog header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: '800px' }"
  [draggable]="false" [resizable]="false" (onHide)="cancelar()"
  [contentStyle]="{ 'animation': 'slideDown 0.3s ease-out' }">
    <app-custom-wish-list (listChanges)="changeOfList()" ></app-custom-wish-list>
    <ng-template pTemplate="header">
      <span class="text-xl  font-bold">Por favor confirma la dirección de envío  o agrega una diferente</span>
    </ng-template>
    <hr />
    <div class="flex justify-content-between mx-2 sm:mx-3 md:mx-4 lg:mx-5">
      <p>Dirección</p> <div class="flex justify-content-between align-items-center font-bold ml-3"><p>{{newDirectionForm.controls['address'].value}}</p>  <i *ngIf="!editDirection" class="pi pi-pencil" [ngStyle]="editButtonCssOptions"  (click)="showEditDirection()" pTooltip="Editar Dirección" ></i>  <i *ngIf="editDirection" [ngStyle]="editButtonCssOptions" class="pi pi-times outlined-icon" (click)="showEditDirection()"></i> </div>
    </div>
    <form autocomplete="off" [formGroup]="newDirectionForm" *ngIf="editDirection" @fadeSlide>
      <div class="p-field mb-3">
        <custom-dropdown-accesor
          [data]="states"
          formControlName="state"
          placeholder="Departamento"
          label="name"
          filterBy="name"
          dropdownMessage="Seleccione un departamento"
        />
      </div>
      <div class="p-field mb-3">
        <custom-dropdown-accesor
          [data]="cities"
          formControlName="city"
          placeholder="Ciudad"
          label="name"
          filterBy="name"
          dropdownMessage="Seleccione una ciudad"
        />
      </div>
      <div class="p-field mb-3">
        <custom-input-accesor formControlName="newAddress"
        placeholder="Nueva Dirección"
        [form]="newDirectionForm"
        inputName="newAddress"
        type="text"
        />
        <span class="ml-5 text-xs font-bold"> Ejemplo: Calle 13 # 4 -70</span>
      </div>
    </form>
    <hr />
    <ng-template pTemplate="footer">
      <p-button label="Cancelar" (click)="cancelar()"></p-button>
      <p-button
        (click)="deleteMakeOrderLocalStorage()"
        severity="warning"
        label="REALIZAR PEDIDO"
        [disabled]="newDirectionForm.status == 'INVALID' &&  editDirection"
      >
      </p-button>
    </ng-template>
</p-dialog>
